module.exports = __webpack_public_path__ + "img/dream_house.6c683f80.png";